import React from "react";
import { Col } from "reactstrap";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";


const AuthSlider = () => {
    return (
        <React.Fragment>
            <Col lg={6}>
                <div className="p-lg-5 p-4 auth-one-bg h-100">
                    <div className="bg-overlay"></div>
                    <div className="position-relative h-100 d-flex flex-column">
                        <div className="mt-auto">
                            <div className="mb-3">
                                <i className="ri-double-quotes-l display-4 text-secondary"></i>
                            </div>

                            <Carousel showThumbs={false} autoPlay={true} showArrows={false} showStatus={false} infiniteLoop={true} className="slide" 
                            // id="qoutescarouselIndicators"
                            >
     <div className="carousel-inner text-center text-white-50 pb-5 mb-10">
                                    <div className="item">
                                        <img src="/login1.png" alt="" className="h-80 w-80"/>
                                        <p className="text-2xl">Expense Tracker</p>
                                        <p className="fs-15 fst-italic">Record your daily transactions within seconds.</p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white-50 pb-5 mb-10">
                                    <div className="item">  
                                        <img src="/login2.png" alt="" className="h-80 w-80"/>
                                        <p className="text-2xl">Financial Well Being</p>
                                        <p className="fs-15 fst-italic">Set budgets that are easy to stick to, based on your own spending habits.</p>
                                    </div>
                                </div>
                                <div className="carousel-inner text-center text-white-50 pb-5 mb-10">
                                    <div className="item">  
                                        <img src="/login3.png" alt="" className="h-80 w-80"/>
                                        <p className="text-2xl">Visualize Expenses</p>
                                        <p className="fs-15 fst-italic">Understand where your money comes and goes with easy-to-read graphs.</p>
                                    </div>
                                </div>
                              
                            </Carousel>

                        </div>
                    </div>
                </div>
            </Col>
        </React.Fragment >
    );
};

export default AuthSlider;